module.exports = __webpack_public_path__ + "img/iconMposCheck.8e86ec87.svg";